import React, { useMemo, useState } from "react";
import { SHIFT_COLOR_COUNT, resolveShiftForDay } from "./shiftUtils";

export default function RosterLegend({
  teamData,
  shiftTemplates,
  showExceptions,
  onToggleExceptions,
}) {
  const [collapsed, setCollapsed] = useState(false);

  const shiftCounts = useMemo(() => {
    const counts = new Map(shiftTemplates.map((s) => [s.id, 0]));
    let unmatched = 0;
    if (!teamData?.users) return { counts, unmatched };

    for (const user of teamData.users) {
      const seen = new Set();
      for (const day of Object.values(user.days || {})) {
        if (day.type !== "WORKING") continue;
        const shift = resolveShiftForDay(day, shiftTemplates);
        if (shift) seen.add(shift.id);
        else unmatched++;
      }
      seen.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
    }
    return { counts, unmatched };
  }, [teamData, shiftTemplates]);

  if (collapsed) {
    return (
      <div className="roster-legend roster-legend--collapsed">
        <button
          className="roster-legend-toggle"
          onClick={() => setCollapsed(false)}
        >
          ▸ Legend
        </button>
      </div>
    );
  }

  return (
    <div className="roster-legend">
      <div className="roster-legend-header">
        <span className="roster-legend-title">Legend</span>
        <button
          className="roster-legend-toggle"
          onClick={() => setCollapsed(true)}
        >
          ✕
        </button>
      </div>

      <div className="roster-legend-section">
        <div className="roster-legend-subtitle">Shifts</div>
        {shiftTemplates.map((shift, idx) => {
          const colorIndex = idx % SHIFT_COLOR_COUNT;
          // const count = shiftCounts.counts.get(shift.id) || 0;
          return (
            <div key={shift.id} className="roster-legend-item">
              <span className={`roster-legend-dot range-color-${colorIndex}`} />
              <span className="roster-legend-name">{shift.name}</span>
              <span className="roster-legend-hours">
                {shift.workStartTime}–{shift.workEndTime}
              </span>
              {/* {count > 0 && (
                <span className="roster-legend-count">{count}</span>
              )} */}
            </div>
          );
        })}
      </div>

      <div className="roster-legend-section">
        <div className="roster-legend-subtitle">Day types</div>
        {[
          { cls: "roster-cell--wo", code: "–", label: "Weekly off" },
          { cls: "roster-cell--holiday", code: "✕", label: "Public holiday" },
          { cls: "roster-cell--leave", code: "L", label: "Leave / off" },
          { cls: "roster-cell--half", code: "½", label: "Half day" },
          {
            cls: "roster-cell--working",
            code: "W",
            label: "Working (no shift)",
          },
        ].map(({ cls, code, label }) => (
          <div key={code} className="roster-legend-item">
            <span className={`roster-legend-sample ${cls}`}>{code}</span>
            <span className="roster-legend-name">{label}</span>
          </div>
        ))}
      </div>

      {/* <div className="roster-legend-section">
        <label className="roster-legend-toggle-label">
          <input type="checkbox" checked={showExceptions} onChange={onToggleExceptions} />
          Show exceptions only
        </label>
      </div> */}
    </div>
  );
}
